import ScrollAnime from "./anime/scroll";
import ScrollInterview from "./anime/scroll_interview";
import Anchor from "./ui/anchor";
import Modal from "./ui/modal.es6";

export default class Main {
    constructor() {
        this._init();
    }

    _init() {
        this.scroll = new ScrollAnime();
        this.scrollInterview = new ScrollInterview();
        this.anchor = new Anchor();
        this.modal = new Modal();
    }
}
